import type { WorkflowRunNode } from '@/types'
import { RotateCw } from 'lucide-react'
import { formatDateTime } from '@/lib/timeFormatters'

interface Props {
  node: WorkflowRunNode
}

export function RetryInfoBlock({ node }: Props) {
  const showAutoRetries = node.maxRetries > 0 && node.retryCount > 0
  const showManualRetries = node.manualRetryCount > 0
  const showNextRetry = node.status === 'RetryPending' && node.nextRetryAt != null

  if (!showAutoRetries && !showManualRetries && !showNextRetry) return null

  return (
    <div
      data-testid="node-retry-info"
      className="mt-2 bg-muted/40 border border-border rounded p-2"
    >
      <div className="flex items-center gap-1 mb-1">
        <RotateCw className="h-3 w-3 text-muted-foreground" />
        <span className="text-xs font-medium">Attempts</span>
      </div>
      <div className="space-y-1">
        {showAutoRetries && (
          <div className="flex items-center gap-2">
            <span className="text-xs text-muted-foreground">Auto-retries:</span>
            <span className="text-xs font-medium">
              {node.retryCount} of {node.maxRetries}
            </span>
          </div>
        )}
        {showManualRetries && (
          <div className="flex items-center gap-2">
            <span className="text-xs text-muted-foreground">Manual retries:</span>
            <span className="text-xs font-medium">{node.manualRetryCount}</span>
          </div>
        )}
        {showNextRetry && (
          <div className="flex items-center gap-2">
            <span className="text-xs text-muted-foreground">Next retry at:</span>
            <span className="text-xs font-medium">{formatDateTime(node.nextRetryAt)}</span>
          </div>
        )}
      </div>
    </div>
  )
}
